<body>
  <div class="dash">
    <app-sidebar></app-sidebar>
    <div class="dash-app">
      <app-header></app-header>
      <main class="dash-content" style="padding: 20px; margin: 0">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-3">
                          <input type="text" id="gsearch" class="form-control" name="gsearch" style="font-size: 14px"
                            placeholder="search" autocomplete="off" (input)="onSearchChange($event.target.value)" />
                        </div>
                        <div class="col-md-1"></div>
                        <div class="col-md-4 text-center">
                          <select class="form-control font-weight-bold" style="text-align-last: center"
                            (change)="onChangeClinic($event.target.value)">
                            <option *ngFor="
                                let clinic of clinicArray;
                                let index = index
                              " [value]="index">
                              {{ clinic.clinicName }}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-1" style="margin-right: 12px;margin-left: -18px;">
                          <form [formGroup]="slotForm">
                            <select (change)="changeSlot($event)" formControlName="slot">
                              <option value="1" selected="clinic?slot == 1"> Slot One</option>
                              <option value="2" selected="clinic?slot == 2">Slot Two</option>
                            </select>
                          </form>
                        </div>
                        <div class="col-md-3 text-right">
                          <p-calendar [(ngModel)]="date4" (onSelect)="doSomething()" [readonlyInput]="true"
                            [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }" placeholder="search by date"
                            inputStyleClass="text-center"></p-calendar>
                        </div>
                        <div class="col">

                          <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#exampleModal1">Book Appointmemnt</button>
                        </div>
                        
                      </div>
                    </div>

                    <div class="col-md-1 text-right"></div>
                  </div>
                </div>
                <div class="card-body">
                  <table id="example" class="table table-striped table-bordered" style="width: 100%">
                    <div *ngIf="!isData" class="text-center">
                      <h4>No appointments available</h4>
                    </div>
                    <thead *ngIf="isData">
                      <tr>
                        <th id="tb-head">#</th>
                        <th id="tb-head">Paitent Name</th>
                        <th id="tb-head">Address</th>
                        <th id="tb-head">Patient Number</th>
                        <th id="tb-head">Appointment Date</th>
                        <th id="tb-head">Patient Phone</th>
                        <th id="tb-head">App User</th>
                        <th id="tb-head">Status</th>
                        <th id="tb-head">Slot</th>
                        <th id="tb-head">Action</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="!isLoading">
                      <tr class="clickable" style="cursor: pointer" *ngFor="
                          let sinapp of appArray | paginate: config;
                          let index = inde">
                        <td align="center">
                          P-{{ sinapp?.patientId?.registrationNo }}
                        </td>
                        <td align="center">
                          {{ sinapp?.patientName }}
                        </td>
                        <td align="center">
                          {{ sinapp?.address }}
                        </td>
                        <td align="center">
                          {{ sinapp?.appointmentNumber }}
                        </td>

                        <td align="center">
                          {{ moment(sinapp?.appointmentDate).format('MMMM Do YYYY') }}
                        </td>
                        <td align="center">
                          {{ sinapp.patientId?.phoneNo }}
                        </td>

                        <td align="center">
                          {{ sinapp.patientId?.name }}
                        </td>
                        <td align="center">
                          {{ sinapp.appointmentStatus }}
                        </td>
                        <td>
                          {{ sinapp.slot }}
                        </td>
                        <td>
                          <i *ngIf="clinicData && clinicData.type=== 'diagnostic_centre'" class="fa fa-print" (click)="printReciptData(sinapp)" data-toggle="modal" data-target="#exampleModal9" 
                            aria-hidden="true"></i>
                          <a *ngIf="moment(sinapp?.appointmentDate).format('MMMM Do YYYY')  > moment().format('MMMM Do YYYY')"
                            class="btn btn-defaonConfirmAppointmentult" style="margin-left: 10px" type="button" (click)="
                              onCancelAppointment(
                                sinapp.patientId._id,
                                sinapp.appointmentDate,
                                sinapp.appointmentNumber,
                                sinapp.clinicId._id
                              )
                            "><em class="fa fa-times"></em></a>
                          <a *ngIf="clinicData && clinicData.type=== 'diagnostic_centre' && !sinapp.fileCount"  class="btn btn-defaonConfirmAppointmentult"
                            style="margin-left: 10px" type="button" (click)="onSendFile(sinapp?._id)"
                            data-toggle="modal" data-target="#exampleModal">
                            <i class="fa fa-file" aria-hidden="true"></i></a>
                        </td>

                      </tr>
                    </tbody>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <tfoot></tfoot>
                  </table>
                </div>
                <div class="card-footer">
                  <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal9" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Receipt</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" *ngIf="!isLoadingforPrintting">
              <div class="row" >
                <div class="col-6">
                  <select class="form-select" style="margin-bottom: 30px;" [(ngModel)]="Curmember">
                    <option [value]="member" >Select Member</option>
                    <option [value]="member._id" *ngFor="let member of members" >{{member.name}}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <p-multiSelect  [(ngModel)]="selectedItems" [options]="items" [defaultLabel]="'Select-test'"  (onChange)="onChangeTests($event)"></p-multiSelect>
                </div>
                <div class="col-6">
                  <label>Amount :</label>
                  <input style="margin-bottom: 30px;" disabled type="number" class="form-control" id="age"
                  [value]="ammount" (input)="onChangeAmmount($event)" aria-placeholder="Amount" placeholder="Amount"
                    class="form-control">
                </div>
                <div class="col-6">
                  <label>Deposit :</label>
                  <input style="margin-bottom: 30px;" type="number" class="form-control" id="age"
                     aria-placeholder="Deposit" (input)="onChangeDeposit($event)" [value]="deposit"  placeholder="Deposit"
                    class="form-control">
                </div>
                 <div class="col-6">
                  <label>Discount :</label>
                  <input style="margin-bottom: 30px;" type="number" class="form-control" id="age" [value]="discount" 
                     aria-placeholder="Deposit" (input)="onChangeDiscount($event)" placeholder="Discount"
                    class="form-control">
                </div>
                <div class="col-6">
                 <label>Balance :</label>
              <input type="text" class="form-control" disabled [value]="ammount-deposit"  (input)="changesomthing($event)"  id="GuardiansName" formControlName="balance"
                 placeholder="Balance" class="form-control"><br>
                </div>
              </div>
                 <button class="btn btn-primary pull-right" (click)="saveprint()"  type="submit">save & print Receipt</button>
            </div>
            <div class="modal-body" *ngIf="isLoadingforPrintting">
              <p style="height: 400px;" >
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Upload Report</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" style="text-align: center;">
              <app-lab-reports *ngIf="openSendFileView && selectedApptId" [apptId]="selectedApptId"
                (onFileSelect)="onSelectFile($event)"></app-lab-reports>
              <div *ngIf="selectedFile && !successFlag">
                <p>file Slected <br />{{selectedFile.name}}</p>
              </div>
              <div *ngIf="isUploadingTime">
                <div class="spinner">
                  <div class="spinner-circle"></div>
                </div>
                <p>Please wait file uploding ...</p>
              </div>
              <div *ngIf="successFlag">
                <img src="../../../../assets/success.gif" width="100%" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" (click)="handleUploading()" class="btn btn-primary"
                [disabled]="!selectedFile || isUploadingTime || successFlag">Uploads File</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Book Appointmemnt111</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body"  *ngIf="clinicData.isMultiselectorType && clinicData.isMultiselectorType">
             
              <app-token-screen [clinicId]="clinicData._id" [slots]="clinicData?.tokenBookingTime?.length"></app-token-screen>
            </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" (click)="handleUploading()" class="btn btn-primary"
                [disabled]="!selectedFile || isUploadingTime || successFlag">Uploads File</button>
            </div> -->
          </div>
        </div>
      </div>
      <button class="btn btn-primary" (click)="printAppointments(appArray)">printAppointments</button>
    </div>
  </div>
</body>